import { DEFAULT_DRUID_FILTERS_LIST } from './defaultDruidDimensions';
import { JOURNEYS_DIMENSIONS_WHITELIST } from './journeysDimensionsWhitelist';
import { BASE_OTT_DIMENSIONS } from './ottDimensions';

export const SUMMARY_DIMENSIONS_WHITE_LIST = [
  ...DEFAULT_DRUID_FILTERS_LIST,
  ...JOURNEYS_DIMENSIONS_WHITELIST.filter((dimension) => dimension !== 'dismissal_source'),
  ...BASE_OTT_DIMENSIONS,
] as const;
